import React, { useContext } from "react";

// Css
import "./SmallTools.css";

// Material Ui
// #Icons
import FormatBoldIcon from "@material-ui/icons/FormatBold";
import FormatItalicIcon from "@material-ui/icons/FormatItalic";
import FormatUnderlinedIcon from "@material-ui/icons/FormatUnderlined";
import StrikethroughSIcon from "@material-ui/icons/StrikethroughS";

function SmallTools() {
  const runCommand = (typeOfCommand, e) => {
    e.preventDefault();
    document.querySelector(".textEditor").focus();
    document.execCommand(typeOfCommand, false, null);
  };

  return (
    <>
      <div className="small-tools">
        <button
          className="small-tools__button small-tools__bold"
          onClick={(e) => {
            runCommand("bold", e);
          }}
        >
          <FormatBoldIcon />
        </button>
        <button
          className="small-tools__button small-tools__italic"
          onClick={(e) => {
            runCommand("italic", e);
          }}
        >
          <FormatItalicIcon />
        </button>
        <button
          className="small-tools__button small-tools__underline"
          onClick={(e) => {
            runCommand("underline", e);
          }}
        >
          <FormatUnderlinedIcon />
        </button>
        <button
          className="small-tools__button small-tools__strikeThrough"
          onClick={(e) => {
            runCommand("strikeThrough", e);
          }}
        >
          <StrikethroughSIcon />
        </button>
      </div>
    </>
  );
}

export default SmallTools;
